import shape12 from '../../../Assets/img/shape12.svg';
import { ReactComponent as BgHero } from '../../../Assets/img/figura11.svg'
import "./seoCotizador.css";

const TITULO_DEFAULT = "¿Por qué elegirnos?";
const BULLETS_DEFAULT = [
    "<b>Brindamos asesoramiento integral de coberturas</b> y soluciones ajustadas a las necesidades de protección de la actividad económica de comercios, PyMES e industrias.",
    "<b>Ofrecemos servicios</b> durante y post contratación, solicitud, emisión y control de pólizas, cobranzas y atención, asesoramiento y seguimiento de siniestros y análisis de PML.",
    "<b>Nuestra trayectoria y experiencia en el mercado</b> asegurador nos posiciona como un socio estratégico, preparado para brindar una solución integral.",
];

interface Props {
    color?: string;
    titulo?: string;
    bullets?: string[];
    mostrarImagen?: boolean;
    anchoCompleto?: boolean;
}
export const PorQueElegirnos = ({ color, titulo = TITULO_DEFAULT, bullets = BULLETS_DEFAULT, mostrarImagen = true, anchoCompleto = false }: Props) => {
    const columnaTextoClassName = anchoCompleto
        ? "col-12"
        : mostrarImagen ? "col-lg-6 ms-auto" : "col-lg-8 mx-auto";
    const tituloClassName = anchoCompleto
        ? "seo-cotizador-h2 text-start"
        : "ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-35 mb-lg-50 text-center text-lg-start";
    const bulletsClassName = anchoCompleto ? "seo-cotizador-bullets" : "list-unstyled fs-16 fs-lg-20 lh-14 mb-2";
    return (
        <div className="py-40 py-lg-70 position-relative">
            {mostrarImagen && (
                <img className="d-none d-lg-block pos15 blend-multipy" src={shape12} alt="Fondo decorativo" />
            )}
            <div className="container px-25 px-lg-12">
                <div className="row">
                    {mostrarImagen && (
                        <div className="d-none d-lg-block col-lg-6 text-center">
                            <div
                            className={`img-fluid w-380p pt-50 m-auto ${!color && "text-primary"}`}
                            style={{ color }}>
                                <BgHero />
                            </div>
                        </div>
                    )}
                    <div className={columnaTextoClassName}>
                        <h2 className={tituloClassName}>
                            {titulo}
                        </h2>
                        <ul className={bulletsClassName}>
                            {bullets.map((bullet, index) => (
                                <li
                                    key={index}
                                    className={anchoCompleto ? "" : `bullet-circle-primary ps-4 ${index === bullets.length - 1 ? "mb-0" : "mb-25"}`}
                                    dangerouslySetInnerHTML={{ __html: bullet }}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
